import angular from 'angular';

import SaRebootService from '../../../components/api/sa_reboot/sa_reboot.service';

export class SaRebootItemController {
  /*@ngInject*/
  constructor($mdDialog, $timeout, SaRebootService) {
    this.SaRebootService = SaRebootService;
    this.rebooted = false;
    this.rebooting = false;
    this.$mdDialog = $mdDialog;
    this.$timeout = $timeout;
    this.confirmDialog = null;
    this.errorDialog = null;

    this.rebootApiMethod = null;

    this.DialogController = ($scope, $mdDialog, device) => {
      $scope.device = device;
      $scope.closeDialog = function() {
        $mdDialog.hide();
      };
      $scope.cancelDialog = function() {
        $mdDialog.cancel();
      };
    };
  }

  $onChanges() {
    if (this.mode) {
      this.rebootApiMethod = this.SaRebootService.api;
    } else {
      this.rebootApiMethod = this.SaRebootService.oem_api;
    }

    this.confirmDialog = this.$mdDialog.confirm({
      clickOutsideToClose:true,
      template: require('./confirm-dialog.html'),
      locals: { device: this.device },
      controller: ['$scope', '$mdDialog', 'device', this.DialogController]
    });

    this.errorDialog = this.$mdDialog.alert({
      clickOutsideToClose:true,
      title: 'エラーが発生しました',
      content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
      ok: 'OK'
    });
  }

  showConfirm(ev) {
    this.$mdDialog.show(this.confirmDialog.targetEvent(ev))
      .then(() => {
        this.rebooting = true;
        this.rebootApiMethod.reboot({ sa_config_id: this.device.id },
          response => {
            this.$timeout(() => {
              this.rebooting = false;
              this.rebooted = true;
            }, 2000);
          },
          err => {
            this.rebooting = false;
            this.$mdDialog.show(this.errorDialog);
          }
        )
      });
  }
}

export default angular.module('leptonApp.saRebootItem', [SaRebootService])
  .component('saRebootItem', {
    template: require('./sa_reboot_item.html'),
    controller: SaRebootItemController,
    bindings: {
      device: '=',
      mode: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_reboot/sa_reboot_item/sa_reboot_item.component.js